import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';

import { AppState } from '../../reducers';

import { setChannelUserIdAction, setUserPhoneAction, setChannelIdAction, setUserLangAction } from '../../actions/user';
import { authorizationAction, resetSendCodeAuthorizationAction } from '../../actions/Authorization/authorization';

import { IsSendCodeView } from '../RegistrationAuthorization/IsSendCodeView';
import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface AuthorizationIsSendCodeContainerProps extends Props<AuthorizationIsSendCodeContainer> {
    phone: string;
    channelUserId: string;
    channelId: string;
    lang: string;
}

interface AuthorizationIsSendCodeContainerDispatch extends Props<AuthorizationIsSendCodeContainer> {
    onAuthorization: (phone: string, channelUserId: string) => any;
    resetSendCodeAuthorization: () => any;
    setLang: (lang: string) => any;
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
}

function mapProps(state: AppState, props: AuthorizationIsSendCodeContainerProps): AuthorizationIsSendCodeContainerProps {
    return {
        lang: state.userState.lang,
        phone: state.userState.phone,
        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
    };
}

function mapDispatch(dispatch: Dispatch<any>): AuthorizationIsSendCodeContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        onAuthorization: (phone: string, channelUserId: string) => dispatch(authorizationAction(phone, channelUserId)),
        resetSendCodeAuthorization: () => dispatch(resetSendCodeAuthorizationAction()),
    };
}

class AuthorizationIsSendCodeContainer extends React.Component<AuthorizationIsSendCodeContainerProps & AuthorizationIsSendCodeContainerDispatch & RouteProps> {
    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channel = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channel) {
                setChannelId(channel);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
        }
    }

    render() {
        document.title = i18next.t('authorization');
        const { phone, onAuthorization, channelUserId, channelId, lang } = this.props;
        const { history, resetSendCodeAuthorization } = this.props;
        return (
            <IsSendCodeView
                channelId={channelId}
                name={i18next.t('authorization')}
                onSendCode={() => {
                    onAuthorization(phone, channelUserId);
                    history.push(`/authorization?phone=${phone}&channel_id=${channelId}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
                }}
                onClose={() => {
                    resetSendCodeAuthorization();
                    history.push(`/authorization?phone=${phone}&channel_id=${channelId}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
                }}
            />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(AuthorizationIsSendCodeContainer));



// WEBPACK FOOTER //
// ./src/components/Authorization/AuthorizationIsSendCodeContainer.tsx